__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "portalIamMessaging";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("lodash", "4.17.21", () => (__webpack_require__.e(486).then(() => (() => (__webpack_require__(96486))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e(114), __webpack_require__.e(700)]).then(() => (() => (__webpack_require__(30381))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(216), __webpack_require__.e(601)]).then(() => (() => (__webpack_require__(28216))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(197), __webpack_require__.e(410)]).then(() => (() => (__webpack_require__(60197))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(14791))))));
			initExternal(14403);
			initExternal(82038);
			initExternal(23126);
			initExternal(77219);
			initExternal(74668);
			initExternal(35304);
			initExternal(69345);
			initExternal(61536);
			initExternal(44295);
			initExternal(19970);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};